export enum TargetModeFormMode {
  oneAtATime = 'oneAtATime',
  severalAtATime = 'severalAtATime',
}

export interface TargetModeFormType {
  mode: TargetModeFormMode;
  maxReservedWorkers?: number;
}
